import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import NotFound from './views/NotFound.vue'
import Login from './views/Login.vue'
import Receipts from './views/Receipts.vue'
import AllReceipts from './views/AllReceipts.vue'
import Statistics from './views/Statistics.vue'
import Settings from './views/Settings.vue'
import CampaignInfo from './views/CampaignInfo.vue'
import Campaigns from './views/Campaigns.vue'
import blackList from './views/blackList.vue'
import participationCounts from './views/ParticipationCounts.vue'
import Agent from './views/Agent.vue'
import SearchByEmail from './views/SearchByEmail.vue'
import HoldReceipts from './views/HoldReceipts.vue'
import DeclinedPayments from './views/DeclinedPayments.vue'
import FraudReceipts from './views/FraudReceipts.vue'
import rejectedReceipts from './views/rejectedReceipts.vue'
import ExportStatistics from './views/ExportStatistics.vue'
import DataExports from './views/DataExports.vue'
import MistakeReportsExport from './views/MistakeReportsExport.vue'
import Winner from './views/Winner.vue'
import exportWinnerList from './views/ExportWinnerList'
import Raffle from './views/Raffle.vue'
import ServiceOp from './views/ServiceOperators.vue'
import Bouncebacks from './views/Bouncebacks.vue'
import PaymentCorrection from './views/PaymentCorrection.vue'
import PaymentPrep from './views/PaymentPrep.vue'
import AgentL1 from './views/AgentL1.vue'
import DachRaffle from './views/DachRaffle.vue'
Vue.use(Router)

const isAuthenticated = (to, from, next) => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf('userToken') == 0) {
      const userToken = c.substring('userToken='.length, c.length);
      store.commit('setUserToken', userToken);
    }
  }

  if (store.getters.isAuthenticated) {
    next();
    return
  }
  next('/login')
}

const logout = (to, from, next) => {
  document.title = 'Dashboard';
  document.cookie = 'userToken=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  store.commit('setUserToken', '');
  localStorage.selectedDashboard=undefined;
  store.dispatch('snackAlert', { message: 'Logout successfull', type: 'success' })
  next('/login')
}
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Receipts,
      beforeEnter: isAuthenticated
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/agent',
      name: 'agent',
      component: Agent,
      beforeEnter: isAuthenticated
    },
    {
      path: '/searchByEmail',
      name: 'searchByEmail',
      component: SearchByEmail,
      beforeEnter: isAuthenticated
    },
    {
      path: '/holdReceipts',
      name: 'holdReceipts',
      component: HoldReceipts,
      beforeEnter: isAuthenticated
    },
    {
      path: '/dataFiles',
      name: 'dataFiles',
      component: DataExports,
      beforeEnter: isAuthenticated
    },
    {
      path: '/mistakeReportsExport',
      name: 'mistakeReportsExport',
      component: MistakeReportsExport,
      beforeEnter: isAuthenticated
    },
    {
      path: '/declinedPayments',
      name: 'declinedPayments',
      component: DeclinedPayments,
      beforeEnter: isAuthenticated
    },
    {
      path: '/fraudReceipts',
      name: 'fraudReceipts',
      component: FraudReceipts,
      beforeEnter: isAuthenticated
    },
    {
      path: '/receipts',
      name: 'receipts',
      component: Receipts,
      beforeEnter: isAuthenticated
    },
    {
      path: '/allReceipts',
      name: 'allReceipts',
      component: AllReceipts,
      beforeEnter: isAuthenticated
    },
    {
      path: '/rejectedReceipts',
      name: 'rejectedReceipts',
      component: rejectedReceipts,
      beforeEnter: isAuthenticated
    },
    {
      path: '/blackList',
      name: 'blackList',
      component: blackList,
      beforeEnter: isAuthenticated
    },
    {
      path: '/ParticipationCounts',
      name: 'participationCounts',
      component: participationCounts,
      beforeEnter: isAuthenticated
    },
    {
      path: '/winnerList',
      name: 'winnerList',
      component: Winner,
      beforeEnter: isAuthenticated
    },
    {
      path: '/exportWinnerList',
      name: 'exportWinnerList',
      component: exportWinnerList,
      beforeEnter: isAuthenticated
    },
    {
      path: '/raffle',
      name: 'Raffle',
      component: Raffle,
      beforeEnter: isAuthenticated
    },
    {
      path: '/dach-raffle',
      name: 'DachRaffle',
      component: DachRaffle,
      beforeEnter: isAuthenticated
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: Statistics,
      beforeEnter: isAuthenticated
    },
    {
      path: '/exportStatistics',
      name: 'ExportStatistics',
      component: ExportStatistics,
      beforeEnter: isAuthenticated
    },
    {
      path: '/paymentCorrection',
      name: 'PaymentCorrection',
      component: PaymentCorrection,
      beforeEnter: isAuthenticated
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      beforeEnter: isAuthenticated
    },
    {
      path: '/campaignInfo',
      name: 'campaignInfo',
      component: CampaignInfo,
      beforeEnter: isAuthenticated
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: logout
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: Campaigns,
      beforeEnter: isAuthenticated
    },
    {
      path: '/serviceOp',
      name: 'serviceOp',
      component: ServiceOp,
      beforeEnter: isAuthenticated
    },
    {
      path: '/agentL1',
      name: 'agentL1',
      component: AgentL1,
      beforeEnter: isAuthenticated
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    },
    {
      path: '/bouncebacks',
      name: 'bouncebacks',
      component: Bouncebacks,
      beforeEnter: isAuthenticated
    },
      {
      path: '/paymentPrep',
      name: 'paymentPrep',
      component: PaymentPrep,
      beforeEnter: isAuthenticated
    }
  ]
})
